import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {IBetWayWinData, LonerGameData} from "../../server/LonerData";
import {LonerStatics} from "../../LonerStatics";
import {Loner} from "../../Loner";
import {LonerGameMode} from "../../server/LonerGameMode";
import {LonerSymbol} from "../../reels/symbols/main/LonerSymbol";
import {LonerSymbolStates, SYMBOL_NAMES} from "../../../core/reel/ReelInterfaces";
import {LonerSound} from "../../sound/LonerSound";

export class LonerIndividualWinView extends PIXI.Container implements StageLayer {

    private static WIN_COMBO_SHOW_DURATION:number = 0.65;
    private static SHOW_NO_WINS_DURATION:number = 0.25;

    private _mainTL:gsap.core.Timeline;
    private _betWayWinData:IBetWayWinData[] = [];
    private _allWinData:IBetWayWinData;
    private _shouldRun:boolean;

    constructor() {
        super();
        this.name = "LonerIndividualWinView";
        this.position = LonerStatics.MAIN_REELS_VIEW_POSITION;
        this._allWinData = {
            reelWinPositions : [],
            multipliedAmount : 0,
            numberOfCombinations : 0,
            amount : 0,
            multiplier : 0,
            length : 0,
            symbol : "L1"
        };
        this._shouldRun = false;
    }

    public start():void {
        if (this._shouldRun == false){
            return;
        }
        const data:LonerGameData = Loner.model.gameData;
        Loner.winWaysView.visible = true;

        if(data && data.nextMode == LonerGameMode.NORMAL && data.mode == LonerGameMode.NORMAL) {
            if(Loner.model.brokeBank == true) {
                this._allWinData.reelWinPositions = Loner.model.allWinSymPositions;
                this._allWinData.multipliedAmount = Loner.model.accumulatedRoundWin;
                this._allWinData.numberOfCombinations = Loner.model.totalWaysWon;
                this._allWinData.multiplier = 1;// don't show multiplier
                this._betWayWinData.push(this._allWinData);
            } else if(data.betWayWins.length > 0 && data.totalSpinWinnings > 0) {
                this._betWayWinData = data.betWayWins;
                if(this._betWayWinData.length > 1) {
                    this._allWinData.reelWinPositions = Loner.model.allWinSymPositions;
                    this._allWinData.multipliedAmount = Loner.model.totalSpinWinnings;
                    this._allWinData.numberOfCombinations = Loner.model.totalWaysWon;
                    this._betWayWinData.push(this._allWinData);
                }
            }

            gsap.timeline().add(() => {this.getMainTL()}, "+=1");
        }
    }

    private getMainTL():void {
        if (this._shouldRun == false){
            return;
        }
        Loner.winWaysView.setYPosWays(55);
        this._mainTL = gsap.timeline({repeat : -1});
        let winComboTL:gsap.core.Timeline;
        let subSymbolTLs:gsap.core.Timeline[];
        let subWinContainerTLs:gsap.core.Timeline[];

        const allToToggleNormalTL:gsap.core.Timeline = gsap.timeline();
        const subTL:gsap.core.Timeline[] = [];
        for(let j:number = 0; j < Loner.initialWinView.winContainers.length; j++) {
            allToToggleNormalTL.add(Loner.initialWinView.winContainers[j].getFadeOutTL());
            for(let k:number = 0; k < Loner.initialWinView.winContainers[j].winComboSymbols.length; k++) {
                allToToggleNormalTL.add(() => {
                    if(Loner.initialWinView.winContainers[j].winComboSymbols[k].symbolName !== SYMBOL_NAMES.wild2X2
                        && Loner.initialWinView.winContainers[j].winComboSymbols[k].symbolName !== SYMBOL_NAMES.wild3X3) {
                        subTL.push(Loner.initialWinView.winContainers[j].winComboSymbols[k].getNewStateAnimation(LonerSymbolStates.TOGGLE_NORMAL, 0.1));
                    }
                });
            }
        }

        //Since Big Wild can be outside reel area we do it like this
        if (Loner.model.bigWildOnReels.includes(true) && Loner.model.bigWildSize > 0){
            if (Loner.model.bigWildSize == 3 && Loner.model.bigWildReelPosition > 0 && Loner.model.bigWildReelPosition < 8) {
                subTL.push(Loner.wildSymbolPool.getActivePresentationBigWild().getNewStateAnimation(LonerSymbolStates.TOGGLE_NORMAL, 0.1));
            } else if (Loner.model.bigWildReelPosition > 1 && Loner.model.bigWildReelPosition < 7) {
                subTL.push(Loner.wildSymbolPool.getActivePresentationBigWild().getNewStateAnimation(LonerSymbolStates.TOGGLE_NORMAL, 0.1));
            }
        }

        allToToggleNormalTL.add(subTL);
        this._mainTL.add(allToToggleNormalTL);
        this._mainTL.add(gsap.timeline({delay : LonerIndividualWinView.SHOW_NO_WINS_DURATION}));

        for(let i:number = 0; i < this._betWayWinData.length; i++) {
            subSymbolTLs = [];
            //Add all win combos except all wins
            if(i < this._betWayWinData.length - 1) {
                winComboTL = gsap.timeline();
                for(let j:number = 0; j < Loner.initialWinView.winContainers.length; j++) {
                    //Fade out all no-win combo symbols container
                    winComboTL.add(Loner.initialWinView.winContainers[j].getFadeOutTL());

                    for(let k:number = 0; k < Loner.initialWinView.winContainers[j].winComboSymbols.length; k++) {
                        winComboTL.add(() => {
                            //If symbol is part of win combo let it stay in TOGGLE WIN (no blinking sym)
                            if(!Loner.initialWinView.winContainers[i].winComboSymbols.includes(Loner.initialWinView.winContainers[j].winComboSymbols[k])) {
                                subSymbolTLs.push(Loner.initialWinView.winContainers[j].winComboSymbols[k].getNewStateAnimation(LonerSymbolStates.TOGGLE_NORMAL, 0.1));
                            }
                        });
                    }
                }
                winComboTL.add(subSymbolTLs);

                //Fade in the win combo symbols container
                winComboTL.add(() => {
                    for(let k:number = 0; k < Loner.initialWinView.winContainers[i].winComboSymbols.length; k++) {
                        Loner.initialWinView.winContainers[i].winComboSymbols[k].getNewStateAnimation(LonerSymbolStates.TOGGLE_WIN, 0.1);
                    }
                });

                //Since Big Wild can be outside reel area we do it like this
                winComboTL.add(() => {
                    if (Loner.model.bigWildOnReels.includes(true) && Loner.model.bigWildSize > 0){
                        if (Loner.model.bigWildSize == 3 && Loner.model.bigWildReelPosition > 0 && Loner.model.bigWildReelPosition < 8) {
                            subWinContainerTLs.push(Loner.wildSymbolPool.getActivePresentationBigWild().getNewStateAnimation(LonerSymbolStates.TOGGLE_WIN, 0.13));
                        } else if (Loner.model.bigWildReelPosition > 1 && Loner.model.bigWildReelPosition < 7) {
                            subWinContainerTLs.push(Loner.wildSymbolPool.getActivePresentationBigWild().getNewStateAnimation(LonerSymbolStates.TOGGLE_WIN, 0.13));
                        }
                    }
                })

                winComboTL.add(Loner.initialWinView.winContainers[i].getFadeInTL());

                this._mainTL.add(() => {Loner.winWaysView.getToggleWinTL(this._betWayWinData[i].multipliedAmount, this._betWayWinData[i].numberOfCombinations, 0.2)});
                this._mainTL.add(winComboTL);

                this._mainTL.add(gsap.timeline({delay : LonerIndividualWinView.WIN_COMBO_SHOW_DURATION}));
            } else {
                //Show all wins. Fade in all win syms at once
                subWinContainerTLs = [];
                const allwinComboTL:gsap.core.Timeline = gsap.timeline();
                for(let j:number = 0; j < Loner.initialWinView.winContainers.length; j++) {
                    //Fade in all win combo lines
                    allwinComboTL.add(() => {Loner.initialWinView.winContainers[j].getFadeInTL()});

                    for(let k:number = 0; k < Loner.initialWinView.winContainers[j].winComboSymbols.length; k++) {
                        allwinComboTL.add(() => {
                            //Set all syms in win combo to TOGGLE WIN
                            subWinContainerTLs.push(Loner.initialWinView.winContainers[j].winComboSymbols[k].getNewStateAnimation(LonerSymbolStates.TOGGLE_WIN, 0.13));
                        });
                    }
                }

                //Since Big Wild can be outside reel area we do it like this
                allwinComboTL.add(() => {
                    if (Loner.model.bigWildOnReels.includes(true) && Loner.model.bigWildSize > 0){
                        if (Loner.model.bigWildSize == 3 && Loner.model.bigWildReelPosition > 0 && Loner.model.bigWildReelPosition < 8) {
                            subWinContainerTLs.push(Loner.wildSymbolPool.getActivePresentationBigWild().getNewStateAnimation(LonerSymbolStates.TOGGLE_WIN, 0.13));
                        } else if (Loner.model.bigWildReelPosition > 1 && Loner.model.bigWildReelPosition < 7) {
                            subWinContainerTLs.push(Loner.wildSymbolPool.getActivePresentationBigWild().getNewStateAnimation(LonerSymbolStates.TOGGLE_WIN, 0.13));
                        }
                    }
                })

                allwinComboTL.add(subWinContainerTLs);

                this._mainTL.add(() => {Loner.winWaysView.getToggleWinTL(this._betWayWinData[i].multipliedAmount, this._betWayWinData[i].numberOfCombinations, 0.15)});
                this._mainTL.add(allwinComboTL);
                this._mainTL.add(gsap.timeline({delay : LonerIndividualWinView.WIN_COMBO_SHOW_DURATION}));
                this._mainTL.add(() => {Loner.winWaysView.getHideToggleWin(0.1)});
            }
        }
    }

    public stop():void {
        this._shouldRun = false;
        if(this._mainTL) {
            this._mainTL.pause();
            this._mainTL.kill();
            Loner.winWaysView.getHideToggleWin();
        }
        this._betWayWinData = [];

        //Fade out dark overlay and win animation on all syms
        for(let i:number = 0; i < Loner.allReelView.mainReelModels.length; i++) {
            for(let j:number = 0; j < Loner.allReelView.mainReelModels[i].reelView.symbols.length; j++) {
                (<LonerSymbol>Loner.allReelView.mainReelModels[i].reelView.symbols[j]).makeReadyForSpin();
            }
        }
    }

    get shouldRun():boolean {
        return this._shouldRun;
    }

    set shouldRun(value:boolean) {
        this._shouldRun = value;
    }
}